import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '@common/global';
@Injectable({
  providedIn: 'root'
})
export class OpenstreetmapService {

  constructor(private _global: GlobalService, private http: HttpClient) { }
  search(query) {
    return this.http.post('https://nominatim.openstreetmap.org/search?' + query, {}).map(data => {
      return data;
    });
  }
}